export default __webpack_public_path__ + "static/media/ye.f5eed2e9.svg";